import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface RecoverFromTokenResponse extends BackendResponse {}

export interface RecoverFromTokenParameters extends NextApiParams {
  recoveryToken: string;
}

export const recoverFromToken = withNextApi<
  RecoverFromTokenResponse,
  RecoverFromTokenParameters
>("/auth/RecoverFromToken");
